@if (definition; as def) {
  @switch (def.control) {
    @case ('tabGroup') {
      <soft-tab-group
        [ngClass]="def.class | classRule: form.value"
        >
        @for (tab of def.definitions; track tab) {
          @if (tab.visible | booleanRule: form.value:true) {
            <soft-tab
              [ngClass]="tab.class | classRule: form.value"
              [title]="tab.title"
              >
              <ng-container
          *ngTemplateOutlet="
            valueTemplate;
            context: { $implicit: $any(tab).definitions }
          "
              ></ng-container>
            </soft-tab>
          }
        }
      </soft-tab-group>
    }
    @case ('card') {
      <div
        class="w-full"
        >
        @if (def.title) {
          <div class="soft-overline">
            {{ def.title }}
          </div>
        }
        <div class="soft-card w-full"
          [ngClass]="def.class | classRule: form.value">
          <ng-container
        *ngTemplateOutlet="
        valueTemplate;
        context: { $implicit: def.definitions }
      "
          ></ng-container>
        </div>
      </div>
    }
    @case ('section') {
      <section
        class="soft-section w-full"
        >
        @if (def.title) {
          <div class="soft-overline">{{ def.title }}</div>
        }
        <div [ngClass]="def.class | classRule: form.value">
          <ng-container
        *ngTemplateOutlet="
        valueTemplate;
        context: { $implicit: def.definitions }
      "
          ></ng-container>
        </div>
      </section>
    }
    @case ('div') {
      <div
        class="w-full"
        >
        @if (def.title) {
          <div class="soft-overline">{{ def.title }}</div>
        }
        <div [ngClass]="def.class | classRule: form.value">
          <ng-container
        *ngTemplateOutlet="
        valueTemplate;
        context: { $implicit: def.definitions }
      "
          ></ng-container>
        </div>
      </div>
    }
  }
}

<ng-template let-children #valueTemplate>
  @for (child of children; track child) {
    <div
      [ngClass]="child.class | classRule: form.value"
      class="soft-dynamic-form-field"
      >
      @if (child.visible | booleanRule: form.value:true) {
        <ng-container
          softDynamicFormField
          [definition]="child"
          [form]="formGroupDirective"
        ></ng-container>
      }
    </div>
  }
</ng-template>
